import { useCallback, useRef, useState } from 'react';
import type { MutableRefObject, Ref } from 'react';
import { nanoid } from 'nanoid';

const useDeferredRef = <T extends HTMLElement>(): [MutableRefObject<T | null>, string, Ref<T>] => {
    const ref = useRef<T | null>(null);
    const [signal, setSignal] = useState<string>('');
    const updateRef = useCallback((el: T): void => {
        ref.current = el;
        setSignal(nanoid());
    }, []);

    return [ref, signal, updateRef];
};

export { useDeferredRef };
